import { prepareRequestUrl } from './server';
export const createEventSource = (endpointConfig) => {
    const url = prepareRequestUrl(endpointConfig);
    const eventSource = new EventSource(url);
    return eventSource;
};
